<template>
  <div :class="s.wrap">
    <div :class="s.bg_wrap">
      <div :class="s.bg"/>
    </div>
    <div :class="s.main">
      <div :class="s.logo">
        <img :class="s.pc" src="/img/pages/specialcampaign/sharecampaign.svg" alt="">
        <img :class="s.sp" src="/img/pages/specialcampaign/sharecampaign_sp.svg" alt="">
      </div>

      <!-- #1万円の使い方キャンペーン -->
      <div :class="s.title_wrap">
        <div :class="s.me">
          <img src="/img/items/me.png" alt="">
        </div>
        <div :class="s.title">
          <img src="/img/pages/specialcampaign/howtouse.svg" alt="">
        </div>
      </div>

      <!-- 詳細 -->
      <div :class="[s.cloud_wrap, s.about]">
        <div :class="s.about_title_sub">アカウントフォロー&シェアで</div>
        <div :class="s.about_title"><span class="nowrap">Amazonギフト券</span><br>10,000円分を<span class="nowrap">10名様に</span><br>プレゼント<span :class="s.rotate">!</span></div>
        <div :class="s.about_description">「ちょいくせ未来予報」の結果をみんなにシェアしよう! さらに、<span :class="s.yellow_bold">1万円の使い方を書けば、</span>なんと<span :class="s.yellow_bold">当選確率が2倍に!?</span>ステキな投稿は公式 X でリポスト! 優秀賞も発表します。</div>
        <div :class="[s.pig, s.gif]"><img src="/img/items/buta_1.gif" alt=""></div>
        <div :class="s.end"><img src="/img/pages/specialcampaign/end.svg" alt=""></div>
      </div>

      <!-- 応募期間 -->
      <div :class="[s.cloud_wrap, s.limit]">
        <div :class="s.cloud_title">応募期間</div>
        <img :class="s.pc" src="img/pages/specialcampaign/limit_pc.svg" alt="">
        <img :class="s.sp" src="img/pages/specialcampaign/limit_sp.svg" alt="">
      </div>

      <!-- 応募方法 -->
      <div :class="[s.cloud_wrap, s.how_to]">
        <div :class="s.cloud_title">応募方法</div>
        <ul :class="s.steps">
          <li v-for="(step, i) in steps" :key="i">
            <div :class="s.step">STEP<span>{{ i + 1 }}</span></div>
            <div v-html="step"/>
            <div :class="s.arrow" v-if="i < 2">
              <img src="/img/effects/campaign_arrow.png" alt="">
            </div>
          </li>
        </ul>
        <div :class="s.bubble_wrap">
          <div :class="s.bubble">
            <img :class="s.comment" src="/img/pages/specialcampaign/howto_bubble_left.svg" alt="">
            <img :class="s.buta" src="/img/items/buta_2.gif" alt="">
          </div>
        </div>
      </div>

      <!-- 応募資格 -->
      <div :class="[s.cloud_wrap, s.qualification]">
        <div :class="s.cloud_title">応募資格</div>
        <div>15〜18歳の高校生</div>
        <div :class="s.qualification_note">※自称高校生の参加は不問とします</div>
      </div>

      <!-- 応募規約 -->
      <div :class="[s.cloud_wrap, s.terms]">
        <div :class="s.cloud_title">応募規約</div>
        <div :class="s.content_wrap">
          <div
            :class="s.trigger">
            <div :class="s.trigger_img">
              <img
                @click="triggerClicked"
                src="/img/effects/trigger_main.svg" alt="">
            </div>
            <img
              :class="s.trigger_giza"
              src="/img/effects/giza.svg" alt="">
          </div>
          <!-- content -->
          <div
            id="accordion-content"
            :class="[s.content, flag.showTerms ? s.show : '']">
            <div :style="`max-height: ${accordionMaxH}px;`">
              <ul :class="s.terms_content">
                <li
                  v-for="(item, i) in terms"
                  :key="i">
                  <div :class="s.terms_label">[{{ item.label }}]</div>
                  <div :class="s.terms_detail" v-html="item.detail" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flag: {
        showTerms: false,
      },
      steps: [
        '<span class="nowrap">「ちょいくせ未来予報」</span>に<span class="nowrap">チャレンジ！</span>',
        '<a href="https://x.com/seeboncho" target="_blank"><span class="nowrap">公式Xアカウント</span>（@seeboncho）</a>を<span class="nowrap">フォロー&診断結果</span>を<span class="nowrap">Xでシェア</span>',
        '「ここに10,000円の使い方を<span class="nowrap">書いてね」を</span>消して、<span class="nowrap">あなたらしい使い方を記入！</span>',
      ],
      terms: [
        {
          label: '運営事務局',
          detail: '本キャンペーンは「<a href="https://www.toushin.or.jp/" target="_blank">一般社団法人投資信託協会</a>」が主催し、キャンペーン事務局が運営しております。なお、適正な運用を行う為に事務局が必要と判断した場合に限り、本キャンペーンの応募条件変更等、あらゆる対応を取ることができるものとさせていただきます。あらかじめご了承ください。詳しくはその他の注意事項をご確認ください。',
        },
        {
          label: 'キャンペーン名',
          detail: 'ちょいくプロジェクト “１万円の使い方”キャンペーン',
        },
        {
          label: '商品',
          detail: 'Amazonギフトカード10,000円分 × 10名<br>※本キャンペーン募集の内容および賞品は、予告なく変更される場合があります',
        },
        {
          label: '応募期間',
          detail: '2024年7月5日（金）〜 8月23日（金）23:59までの投稿',
        },
        {
          label: '当選人数',
          detail: '10名様',
        },
        {
          label: '応募条件',
          detail: '・満15歳〜18歳であること<br>・公式Xアカウント（@seeboncho）をフォロー&「ちょいくせ未来予報」の診断結果をシェアされていること ※応募者の投稿は、公式Xアカウント（@seeboncho）によりリポストさせていただく場合がございます。<br>・未成年の方は、保護者の方が応募規約に同意いただいた上でキャンペーンへの応募をお願いいたします。未成年の方が応募された場合は、保護者の同意を得たものとみなします。',
        },
        {
          label: '賞品発送',
          detail: '賞品発送はキャンペーン応募期間終了後の10月中旬頃を予定しております。都合により賞品の発送が多少遅れる場合もございます。当選者の発表は、商品の発送をもって代えさせていただきます。当選者には公式Xアカウントより、DMにてご連絡いたします。DMが開放されていないなど、こちらからコンタクトが取ることが不可能な場合は、当選無効とさせていただきます。',
        },
        {
          label: 'その他の注意事項',
          detail: '本キャンペーンについては下記をお読みいただき、同意いただける場合のみご応募ください。<br>1. 本キャンペーンに応募していただくにあたり、応募者はキャンペーンの運用について事務局の運用方法にしたがうものとし、一切異議申立てを行わないものとします。<br>2. 本キャンペーンの当選連絡および賞品発送に関する連絡に関して、事務局からご連絡をさせていただく場合がございます。<br>3. 本キャンペーンサイトの利用・利用停止・もしくは不能による損害について事務局は一切責任を負いかねます。（各種WEBサービスのサーバーダウンなども含む）<br>4. 本サイトの理由によるいかなるトラブル・損害（直接、間接の損害別を問わず）が発生したとしても一般社団法人投資信託協会は一切の責任を負いません。あらかじめご了承ください。<br>5. ご応募いただく際にお預かりする皆様の個人情報の保護方針については、一般社団法人投資信託協会ホームページ内の「プライバシーポリシー」及び「コミュニティガイドライン」に記載しております。必ずご一読の上、同意した上でご応募ください。なお、本キャンペーンにご応募された方は、本プライバシーポリシーに同意したものとみなします。<br>6. キャンペーンの応募状況及び抽選結果に関するお問い合わせにはお答えしかねますので、予めご了承ください。<br>7. ご応募は日本国内にお住まいの方に限らせていただきます。<br>8. 抽選で獲得された権利は他人に譲渡できません。転売等はお控えください。<br>9. 本キャンペーンはX社及びAmazon社とは一切関係ありません。お問い合わせに関しては、下記お問い合わせ先までご連絡ください。',
        },
        {
          label: '禁止事項',
          detail: '応募を通じて、以下の事項に該当するアカウントからの応募は無効とさせていただく場合があります。<br>また当選後に判明した場合も、当選権利を無効とさせていただく場合があります。<br>・Xの利用規約に違反している。<br>・自動プログラムを利用しての応募。<br>・複数のXアカウントからの応募。<br>・代理応募。（親族の代理応募も禁止となります）<br>・本キャンペーンの運営を妨げる行為。<br>・特定の団体や個人に対する誹謗中傷。<br>・公序良俗に反する行為。<br>・宣伝及び勧誘行為。<br>・その他、運営事務局が不適切だと判断した行為。',
        },
        {
          label: '賠償責任',
          detail: '本サイトの利用に関連して利用者と第三者との間に紛争が発生した場合には、利用者は、自身の責任と費用で当該紛争を解決するものとし、一般社団法人投資信託協会に損害を与えることのないようにするものとします。',
        },
        {
          label: '準拠法および裁判管轄',
          detail: '本キャンペーン規約の解釈・適用に関しましては、日本国法に準拠するものといたします。',
        },
        {
          label: 'お問い合わせ',
          detail: 'このキャンペーンに関するお問い合わせは下記までDMでお願いいたします。 <br>ちょいくプロジェクト公式Xアカウント（＠seeboncho）<br>受付時間　9:00～17:00（土・日・祝日を除く）',
        },
      ],
      accordionMaxH: 0,
    };
  },
  methods: {
    triggerClicked() {
      this.flag.showTerms = !this.flag.showTerms;
      if (this.flag.showTerms) {
        const winH = window.innerHeight;
        const accordionElem = document.getElementById('accordion-content');
        const elemPos = accordionElem?.getClientRects()[0].top;
        if (!accordionElem || !winH) return;
        const bottomLen = winH - elemPos;
        this.accordionMaxH = bottomLen - 20;
      }
    },
  },
};
</script>

<style lang="scss" module="s">
$fs: 28px;
$fs-md: 24px;
$fs-sm: 16px;
$fs-xs: 13px;

.wrap {
  border-top: 2px solid var(--primary-black);
  background-color: var(--primary-yellow);
  padding: 150px calc((100vw - 73vw) / 2) 45px;
  width: 100%;
  position: relative;
  .bg_wrap {
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: absolute;
    transform: translate(calc((100vw - 73vw) / -2), -150px);
  }
  .bg {
    height: 300%;
    width: 300%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-20deg);
    background-image: url('/img/pages/specialcampaign/campaign_bg.png');
    background-size: 300px;
    background-repeat: repeat;
    background-position: center;
  }
}
.main {
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
}
.logo {
  width: 100%;
  img {
    object-fit: contain;
  }
}
.title {
  width: 84.7%;
  margin: 0 auto;
  > img {
    position: relative;
    z-index: 2;
    margin-top: -20px;
    display: block;
    width: 100%;
  }
  &_wrap {
    position: relative;
    margin-top: 30px;
    .me {
      width: 25%;
      margin: 0 auto -5%;
      transform-origin: bottom center;
      animation: sway 2s ease-in-out infinite alternate;
    }
  }

  &_item_wrap {
    position: relative;
    font-size: 20px;
    font-weight: 700;
    margin-right: 3px;
  }
  &_item {
    padding: 2px 4px;
    border: 1px solid var(--primary-black);
    position: relative;
    z-index: 10;
    &.tag {
      width: 36px;
      text-align: center;
      border-radius: 40px;
      font-size: 24px;
      padding: 0;
    }
  }
  .bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 9px;
    left: 9px;
    border: 1px solid var(--primary-black);
    z-index: 5;
    box-sizing: content-box;
    &.tag {
      border-radius: 40px;
      
      &::after, &::before {
        border-radius: 40px;
      }
    }
    &::after, &::before {
      content: '';
      width: 100%;
      height: 100%;
      background-color: inherit;
      border: 1px solid var(--primary-black);
      position: absolute;
    }
    &::before {
      top: -3px;
      left: -3px;
      z-index: 3;
    }
    &::after {
      top: -6px;
      left: -6px;
      z-index: 4;
    }
  }
}
.tag {
  background-color: var(--primary-white);
}
.how {
  background-color: var(--primary-pink);
}
.campaign {
  background-color: var(--primary-green);
}

.cloud_title {
  font-weight: 700;
  font-size: 42px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--primary-pink);
  padding: 20px 80px;
  border: 1px solid var(--primary-black);
  border-radius: 100px;
  z-index: 3;
}

.cloud_wrap {
  position: relative;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  margin-top: 120px;
}

.about {
  padding: 100px max(10%, 40px);
  margin-top: 3%;
  background-image: url('/img/effects/campaign_about.png');
  &_title {
    font-size: 80px;
    font-weight: 700;
    line-height: 1.3;
  }
  &_title_sub {
    font-size: 42px;
    font-weight: 700;
    position: relative;
    display: inline-block;
    margin: 0 0 40px;
    &::after {
      position: absolute;
      content: '';
      width: 100%;
      padding-top: percentage(7 / 186);
      background-image: url('/img/pages/specialcampaign/title_sub_line.svg');
      top: 100%;
      left: 0;
    }
  }
  &_description {
    font-size: $fs;
    font-weight: 700;
    vertical-align: middle;
  }
  span {
    display: inline-block;
    &.rotate {
      transform-origin: bottom center;
      transform: rotate(15deg);
    }
    &.space {
      letter-spacing: 5px;
    }
    &.yellow_bold {
      font-weight: 700;
      line-height: 1;
      background-color: var(--primary-yellow);
    }
  }
  .pig {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 20%;
    transform: translate(20%, 30%);
    &.gif {
      bottom: -2%;
      right: -1%;
      width: 23%;
    }
  }
}

.limit {
  display: flex;
  align-items: baseline;
  justify-content: center;
  width: 100%;
  font-weight: 700;
  font-size: 30px;
  span {
    display: inline-block;
    &.lg {
      font-size: 60px;
      font-weight: 700;
    }
    &.sm {
      font-size: 21px;
    }
  }
}

.end {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(30%, -20%);
  width: 30%;
}

.how_to {
  padding: 100px max(50px, 10%);
  background-image: url('/img/effects/campaign_how_to.png');
  font-weight: 700;
  font-size: $fs;
  line-height: 1.1;
  .steps {
    > li {
      position: relative;
      display: flex;
      align-items: center;
      border-radius: 100px;
      padding: 18px 18px 18px 18px;
      border: 1px solid var(--primary-black);
      background-color: #ffdeca;
      white-space: pre-wrap;
      > * {
        &:nth-child(2) {
          margin-left: 9px;
          font-size: $fs;
          flex: 1;
          overflow-wrap: anywhere;
          word-break: break-all;
          a {
            text-decoration: underline;
            transition: all .3s;
            &:hover {
              opacity: .5;
            }
          }
        }
      }
      .arrow {
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translate(-50%, -10%);
        width: 8%;
        z-index: 2;
      }
      .step {
        background-color: var(--primary-black);
        color: var(--primary-white);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 21px;
        height: 115px;
        width: 115px;
        border-radius: 115px;
        span {
          font-size: 54px;
          line-height: 1;
        }
      }
      &:not(:first-child) {
        margin-top: 23px;
      }
    }
  }
  .bubble_wrap {
    position: relative;
    width: 100%;
    .bubble {
      position: absolute;
      display: flex;
      width: 100%;
      right: 0;
      transform: translateY(10%);
      .comment {
        width: 70%;
        position: absolute;
        top: -13%;
      }
      .buta {
        width: 50%;
        position: relative;
        top: -3vw;
        right: -61%;
        transform: rotate(15deg);
      }
    }
  }
}

.qualification {
  padding: 74px 120px;
  margin: calc(120px + 10%) auto 0;
  background-image: url('/img/effects/campaign_qualification.png');
  font-weight: 700;
  font-size: $fs;
  display: inline-block;
  min-width: 800px;
  &_note {
    font-size: 16px;
  }
}

.terms {
  font-weight: 700;
  font-size: var(--font-default);
  min-height: calc(100vw * .2);

  .content_wrap {
    position: relative;
  }

  .trigger {
    position: absolute;
    background-image: url('/img/effects/campaign_terms.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    font-size: 14px;
    width: 100%;
    height: calc(100vw * .2);
    &_text, &_giza, &_img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      object-fit: contain;
    }
    &_text {
      font-size: 28px;
      z-index: 3;
    }
    &_img {
      padding-top: 5px;
      width: 25vw;
      min-width: 100px;
      z-index: 2;
      object-fit: contain;
      > img {
        transition: all .3s;
        position: relative;
        z-index: 2;
        transform: translate(-0.4vw, -0.4vw);
      }
      &::before {
        position: absolute;
        width: 25vw;
        min-width: 100px;
        z-index: 1;
        content: '';
        top: 50%;
        left: 50%;
        height: calc(100% - 5px);
        transform: translate(calc(-50% + .4vw), calc(-50% + .4vw));
        background-image: url('/img/effects/trigger_bg.svg');
        transition: all .3s;
        background-repeat: no-repeat;
      }
      &:hover {
        > img {
          transform: translate(.4vw, calc(.4vw - 2.5px));
        }
      }
    }
    &_giza {
      display: block;
      object-fit: contain;
      object-position: center;
      width: 73% !important;
      z-index: 1;
      pointer-events: none;
    }
  }

  .content {
    background-color: var(--primary-white);
    width: 71%;
    margin: 0 auto;
    position: relative;
    transform-origin: top;
    transform: translateY(calc(100vw * .2 / 2 + (100vw - 40px) * .73 * .05 / 2));
    max-height: 0;
    text-align: left;

    .terms_content {
      > li {
        &:not(:first-child) {
          margin-top: 24px;
        }
        .terms_detail {
          font-weight: 600;
        }
        a {
          text-decoration: underline;
        }
      }
    }

    > * {
      width: calc(100% + 2px);
      padding: 42px 42px;
      background-color: var(--primary-white);
      border: 1px solid var(--primary-black);
      border-radius: 0 0 15px 15px;
      border-top: none;
      transition: all .3s;
      transform-origin: top;
      transform: scaleY(0) translateX(-1px);
      overflow: scroll;
    }

    &.show {
      > * {
        transform: scaleY(100%) translateX(-1px);
      }
      &::after {
        content: '';
      }
    }
    
    &::after {
      content: none;
      position: absolute;
      bottom: calc(100% - 1px);
      left: -1px;
      width: calc(100% + 2px);
      height: calc((100vw - 40px) * .73 * 12 / 300 + 1px);
      border: 1px solid;
      border-color: transparent var(--primary-black);

    }
  }
}

@include mdView {
  .wrap {
    $wrap-pdg-x: 60px;
    $wrap-pdg-y: 100px;
    padding: $wrap-pdg-y $wrap-pdg-x 45px;
    .bg_wrap {
      transform: translate(-$wrap-pdg-x, -$wrap-pdg-y);
    }
    .bg {
      background-size: 250px;
    }
  }
  .cloud_wrap {
    margin-top: 80px;
  }
  .cloud_title {
    font-size: 24px;
    padding: 15px 40px;
    border: 1px solid var(--primary-black);
  }
  .about {
    margin-top: 3%;
    &_title {
      font-size: 48px;
    }
    &_title_sub {
      font-size: 32px;
      margin: 0 0 40px;
    }
    &_description {
      font-size: $fs-md;
      margin-top: 20px;
    }
  }
  .end {
    transform: translate(15%, -20%);
  }
  .how_to {
    padding: 100px max(50px, 10%);
    .steps {
      > li {
        padding: 12px;
        > * {
          &:nth-child(2) {
            font-size: $fs-md;
          }
        }
        .step {
          width: 80px;
          height: 80px;
          font-size: 16px;
          span {
            font-size: 32px;
          }
        }
      }
    }
  }
  .qualification {
    margin-top: calc(80px + 10%);
    padding: 40px 80px;
    font-size: $fs-md;
    min-width: 600px;
    &_note {
      font-size: 16px;
    }
  }
  .terms {
    font-size: var(--font-default-md);
    .content {
      > * {
        padding: 22px 32px;
      }
    }
  }
}

@include smView {
  .wrap {
    padding: 35px 40px 45px;
    .bg_wrap {
      transform: translate(-40px, -35px);
    }
    .bg {
      background-size: 180px;
    }
  }
  .title {
    width: 100%;
    &_wrap {
      margin-top: 10px;
    }
  }
  .cloud_wrap {
    margin-top: 30px;
  }
  .cloud_title {
    font-size: 14px;
    padding: 4px 12px;
  }
  .about {
    padding: 56px 30px;
    margin-top: 0;
    &_title {
      font-size: 36px;
    }
    &_title_sub {
      font-size: 20px;
      margin: 0 0 20px;
    }
    &_description {
      font-size: $fs-sm;
      font-weight: 600;
      margin-top: 12px;
    }
  }
  .limit {
    max-width: 450px;
  }
  .end {
    transform: translate(15%, -20%);
  }
  .how_to {
    padding: 50px 30px;
    font-size: $fs-sm;
    white-space: pre-wrap;
    .steps {
      > li {
        padding: 8px 8px 8px 8px;
        &:nth-child(1) {
          > * {
            &:nth-child(2) {
              margin-left: -1em;
            }
          }
        }
        > * {
          &:nth-child(2) {
            margin-left: 0px;
            font-size: $fs-sm;
          }
        }
        .step {
          height: 60px;
          width: 60px;
          font-size: 8px;
          span {
            font-size: 21px;
          }
        }
      }
    }
    .bubble_wrap {
      .bubble {
        left: 0%;
        width: 110%;
      }
    }
  }

  .qualification {
    padding: 30px 60px;
    font-size: $fs-sm;
    margin: calc(30px + 15%) auto 0;
    min-width: auto;
    &_note {
      font-size: 12px;
    }
  }


  .terms {
    font-weight: 700;
    font-size: var(--font-default-sm);
    min-height: calc(100vw * .2);
    .content {
      .terms_content {
        > li {
          &:not(:first-child) {
            margin-top: 24px;
          }
          .terms_detail {
            font-weight: 600;
          }
        }
      }
      > * {
        padding: 22px 20px;
      }
    }
    .trigger {
      &_text {
        font-size: 10px;
      }
    }
  }
}
@include xsView {
  .wrap {
    .bg {
      background-size: 120px;
    }
  }
  .about {
    &_description {
      font-size: $fs-xs;
    }
    &_title {
      font-size: 28px;
      &_sub {
        font-size: 16px;
        margin-bottom: 12px;
      }
    }
  }
  .end {
    width: 40%;
    transform: translate(20%, -10%);
  }
  .how_to {
    padding: 50px 30px;
    font-size: 14px;
    white-space: pre-wrap;
    .steps {
      > li {
        padding: 5px;
        > * {
          &:not(:first-child) {
            font-size: $fs-xs;
          }
        }
        .step {
          height: 40px;
          width: 40px;
          font-size: 8px;
          span {
            font-size: 21px;
          }
        }
      }
    }
    .bubble_wrap {
      .bubble {
        width: 150%;
        left: -15%;
      }
    }
  }
  .qualification {
    font-size: 16px;
    margin-top: calc(30px + 15%);
    &_note {
      font-size: 10px;
    }
  }
  
  .terms {
    font-size: var(--font-default-xs);
    .content {
      .terms_content {
        > li {
          &:not(:first-child) {
            margin-top: 16px;
          }
        }
      }
      > * {
        padding: 22px 16px;
      }
    }
  }
}

.pc {
  @include smView {
    display: none;
  }
}
.sp {
  display: none;
  @include smView {
    display: block;
  }
}

.nowrap {
  white-space: nowrap;
}

@keyframes sway {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(15deg);
  }
  100% {
    transform: rotate(-15deg);
  }
}
</style>
